import { useEffect } from 'react';

interface IProps {
    onCancel: () => void;
}

const PrivacyAgreementPopup = ({ onCancel }: IProps): JSX.Element => {
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data === 'closePrivacyPopup') {
                onCancel();
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [onCancel]);

    return (
        <div id="termsModal-3" className="modal-terms t modal-overlay">
            <div className="modal-content">
                <iframe src="/TERMS_2.html"
                style={{ width: '100%', height:'1000px', border: 'none' }}
                ></iframe>
            </div>
        </div>
    );
};

export default PrivacyAgreementPopup;  